/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.newsletter', {
            parent: 'board.dinghy.event.detail',
            url: '/newsletter',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghyEvent.detail.newsletterTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/newsletter/dinghy-event-newsletter.html',
                    controller: 'DinghyEventNewsletterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('member-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
